import { useEffect } from 'react';

import { useMembership } from '@/hooks/use-membership';
import { useTeamMembers } from '@/hooks/use-team';
import { switchActingProvider, useActingProviderStore } from '@/store/actingProviderStore';
import { useAuthStore } from '@/store/authStore';

/**
 * Derruba o foco que não vale mais: quem não pode agir como outro (virou solo,
 * é profissional, perdeu o acesso) e membro que saiu da equipe ativa. O foco é
 * persistido, então sem isto um app reaberto mandaria o header e a API
 * responderia 403 em tudo.
 */
export function useActingProviderGuard() {
  const acting = useActingProviderStore((s) => s.acting);
  const hasUser = useAuthStore((s) => !!s.user);
  const { can } = useMembership();
  const canActAs = can('actAs');
  const { data: members } = useTeamMembers({ enabled: !!acting && canActAs });

  useEffect(() => {
    if (!acting || !hasUser) return;
    if (!canActAs) {
      switchActingProvider(null);
      return;
    }
    if (
      members &&
      !members.some((m) => m.providerId === acting.providerId && m.status === 'ACTIVE')
    ) {
      switchActingProvider(null);
    }
  }, [acting, hasUser, canActAs, members]);
}
